'use strict';


var util = require('./util');

var stickup = {

	init: function () {

			/* eslint-disable no-unused-vars*/
			//var contentButton = [];
			//var contentTop = [];
			var content = [];
			var lastScrollTop = 0;
			var topBannerHeight = 0;
			var scrollDir = '';
			var itemClass = '';
			var itemHover = '';
			var menuSize = null;
			var stickyHeight = 0;
			var stickyMarginB = 0;
			var currentMarginT = 0;
			/* eslint-enable no-unused-vars*/
			var topMargin = 0;
			var initialNavOffset;
			var isNavActivated = false;
			var activatedNavOffset = 0;
			var varscroll;
			var isScrollActive = false;
			$(window).scroll(function () {
				var st = $(this).scrollTop();
				if (st > lastScrollTop) {
					scrollDir = 'down';
				} else {
					scrollDir = 'up';
				}
				lastScrollTop = st;
			});
			$.fn.stickUp = function (options) {
				// adding a class to users div
				$(this).addClass('stuckMenu');
				//getting options
				var objn = 0;
				if (options !== null) {
					for (var o in options.parts) {
						if (options.parts.hasOwnProperty(o)) {
							content[objn] = options.parts[objn];
							objn++;
						}
					}

					itemClass = options.itemClass;
					itemHover = options.itemHover;
					if (options.topMargin !== null) {
						if (options.topMargin === 'auto') {
							topMargin = parseInt($('.stuckMenu').css('margin-top'));
						} else {
							if (isNaN(options.topMargin) && options.topMargin.search('px') > 0) {
								topMargin = parseInt(options.topMargin.replace('px', ''));
							} else if (!isNaN(parseInt(options.topMargin))) {
								topMargin = parseInt(options.topMargin);
							} else {
								//console.log('incorrect argument, ignored.');
								topMargin = 0;
							}
						}
					} else {
						topMargin = 0;
					}
					menuSize = $('.' + itemClass).length;
				}
				stickyHeight = parseInt($(this).height());
				stickyMarginB = parseInt($(this).css('margin-bottom'));
				currentMarginT = parseInt($(this).next().closest('div').css('margin-top'));
				initialNavOffset = parseInt($(this).offset().top);
			};

			// removed bottomView was unused and causing build warnings

			//run every 100ms;
			setInterval(function () {
				//run only if page has been scrolled;
				if (isScrollActive && $('.stuckMenu').length) {
					varscroll = parseInt($(document).scrollTop());
					if (varscroll <= 0) {
						$('.stuckMenu').removeClass('isStuck');
						$('.breadCrumbsHolder').removeClass('headerStuck');
						$('#main').removeClass('headerStuck');

						$('.stuckMenu').css({
							position: 'relative',
							top: '0px'
						});

						isNavActivated = false;
						activatedNavOffset = 0;

						initialNavOffset = $('.stuckMenu').offset().top;

						isScrollActive = false;
						return;
					}
					topBannerHeight = parseInt($('#main-header').height());
					if ($('#header-cookies-message').is(":visible")) {
						topBannerHeight += parseInt($('#header-cookies-message').height());
					}
					//if navigation is active
					if ($('.menu-category.level-1').is(':visible')) {
						//detects when navigation has been activated
						if (!isNavActivated) {
							isNavActivated = true;
							activatedNavOffset = varscroll;
						//scrolling down
						} else if (activatedNavOffset < varscroll) {
							$('.stuckMenu').css('position', 'absolute');
							$('.stuckMenu').css('top', activatedNavOffset);
						//scrolling up
						} else if (activatedNavOffset > varscroll && varscroll > topBannerHeight) {
							$('.stuckMenu').addClass('isStuck');
							$('.stuckMenu').css('position', 'fixed');
							$('.isStuck').css({
								top: '0px'
							}, 10, function () {});
							//reset activatedNavOffset value
							activatedNavOffset = varscroll;
						}

					} else if (initialNavOffset < varscroll + topMargin) {
						isNavActivated = false;
						$('.stuckMenu').addClass('isStuck');
						$('.breadCrumbsHolder').addClass('headerStuck');
						$('#main').addClass('headerStuck');
						$('.stuckMenu').css('position', 'fixed');
						$('.stuckMenu').each(function() {
							var topPosition = $(this).hasClass('mobile-sticky-summary') && $('#navigation').length
										? `${$('#navigation').outerHeight()}px` : '0px';
							$(this).css({top: topPosition}, 10, function () {});
						});
					}

					if (topBannerHeight > varscroll) {
						$('.stuckMenu').removeClass('isStuck');
						$('.breadCrumbsHolder').removeClass('headerStuck');
						$('#main').removeClass('headerStuck');
						$('.stuckMenu').css('position', 'relative');
						$('.stuckMenu').css('top', '0px');
						initialNavOffset = $('.stuckMenu').offset().top;
					}
					isScrollActive = false;
				}
			}, 100);

			$(document).on('scroll', function () {
				isScrollActive = true;
			});

			this.applySticky();
	},

	applySticky: function () {
		///////////////////////////
		/// Apply to navigation
		///////////////////////////
		if (util.viewport.isBelow1100BreakPoint() && $('#navigation').length) {
			$('#navigation').stickUp({topMargin: 'auto'});
		}
		if ($('#navigation').length) {
			$(window).smartresize(function () {
				if (!util.viewport.isBelow1100BreakPoint()) {
					$('#navigation').removeClass('stuckMenu').removeAttr('style');
				} else {
					$('#navigation').stickUp({
							topMargin: 'auto'
					});
				}
			});
		}
		/**
		 * %TODO REFACTOR:
		 * at least use single class for both status hamper and TC intro box rating
		 */
		///////////////////////////
		/// Apply to hamper status title and content
		///////////////////////////
		if (util.viewport.isMobile() && $('.mobile-status-header').length && $('.hamper-status-container').length) {
				$('.mobile-status-header').stickUp({
					topMargin: 'auto'
				});
				$('.hamper-status-container').stickUp({
					topMargin: 'auto'
				});
		}

		if (util.viewport.isMobile() && $('#rate_tc_mainbox_wrp').length) {
			$('#rate_tc_mainbox_wrp').stickUp({
				topMargin: 'auto'
			});
		}
		if (util.viewport.isMobile() && $('.mobile-sticky-summary').length) {
			var margin = $('#navigation').length ? $('#navigation').outerHeight() : 'auto';
			$('.mobile-sticky-summary').stickUp({
				topMargin: margin
			});
		}
		$(window).on('resize', function () {
			if (!util.viewport.isMobile() && $('.mobile-status-header').length && $('.hamper-status-container').length) {
				$('.mobile-status-header').removeClass('stuckMenu').removeAttr('style');
				$('.hamper-status-container').removeClass('stuckMenu').removeAttr('style');
			} else if ($('.mobile-status-header').length && $('.hamper-status-container').length) {
					$('.mobile-status-header').stickUp({
						topMargin: 'auto'
					});
					$('.hamper-status-container').stickUp({
						topMargin: 'auto'
					});
			}
			if (!util.viewport.isMobile() && $('#rate_tc_mainbox_wrp').length) {
				$('#rate_tc_mainbox_wrp').removeClass('stuckMenu').removeAttr('style');
			} else if ($('#rate_tc_mainbox_wrp').length) {
				$('#rate_tc_mainbox_wrp').stickUp({
					topMargin: 'auto'
				});
			}
			if (!util.viewport.isMobile() && $('.mobile-sticky-summary').length) {
				$('.mobile-sticky-summary').removeClass('stuckMenu').removeAttr('style');
			} else if ($('.mobile-sticky-summary').length) {
				var margin = $('#navigation').length ? $('#navigation').outerHeight() : 'auto';
				$('.mobile-sticky-summary').stickUp({
					topMargin: margin
				});
			}
		});

	}
};

$(document).on('click', '.header-search-btn a', function (e) {
    e.preventDefault();

    var $nav = $('#navigation');

    if ($nav.hasClass('search-active')) {
        $nav.removeClass('search-active');

        var input = document.querySelector('#aa-search-input .aa-Input');
        if (input) {
            input.blur();
            input.value = '';
        }

        return;
    }

    $nav.addClass('search-active');

    setTimeout(function () {
        var input = document.querySelector('#aa-search-input .aa-Input');
        if (input) {
            input.focus();
        }
    }, 100);
});

module.exports = stickup;
